// Impression du document : même méthode que pdf.js (et l'ancien visualiseur). Chaque page est dessinée
// à 150 ppp dans une image, les images vont dans un conteneur visible seulement à l'impression, puis
// window.print(). Plus fiable qu'un PDF imprimé dans un iframe (Safari, Firefox).
// Ctrl+P (Cmd+P sur Mac) lance cette impression à la place de celle de la page du site.

const PPP_IMPRESSION = 150;
const PPP_PDF = 72; // unité des PDF : 1 point = 1/72 de pouce

export function initialiserImpression(section, { pdf }) {
  const bouton      = section.querySelector('[data-action="imprimer"]');
  const attente     = section.querySelector('.pdf-attente');
  const progression = attente.querySelector('.pdf-attente-progression');
  const texte       = attente.querySelector('.pdf-attente-texte');
  let enCours       = false;
  let annule        = false;

  attente.querySelector('[data-action="annuler-impression"]').addEventListener('click', () => {
    annule = true;
  });
  // Échap ferme la boîte : on l'interprète comme une annulation
  attente.addEventListener('cancel', () => {
    annule = true;
  });

  const imprimer = async () => {
    if (enCours) return;
    enCours = true;
    annule  = false;

    const conteneur = document.createElement('div');
    conteneur.className = 'pdf-impression';
    const urls = [];
    const canevas = document.createElement('canvas');

    progression.max = pdf.numPages;
    attente.showModal();

    try {
      for (let numero = 1; numero <= pdf.numPages && !annule; numero++) {
        progression.value = numero - 1;
        texte.textContent = `Préparation de l'impression : page ${numero} sur ${pdf.numPages}`;

        const page     = await pdf.getPage(numero);
        const viewport = page.getViewport({ scale: PPP_IMPRESSION / PPP_PDF });
        canevas.width  = Math.floor(viewport.width);
        canevas.height = Math.floor(viewport.height);
        const contexte = canevas.getContext('2d');
        contexte.fillStyle = '#fff'; // fond blanc des pages (couleur technique du dessin, pas de la page web)
        contexte.fillRect(0, 0, canevas.width, canevas.height);
        await page.render({ canvasContext: contexte, viewport, intent: 'print' }).promise;
        page.cleanup();

        const blob = await new Promise((resolve) => canevas.toBlob(resolve, 'image/png'));
        const url  = URL.createObjectURL(blob);
        urls.push(url);

        const feuille = document.createElement('div');
        feuille.className = 'pdf-impression-page';
        const image = new Image();
        image.alt = '';
        image.src = url;
        await image.decode();
        feuille.append(image);
        conteneur.append(feuille);
      }
    } catch (erreur) {
      console.error('Impression :', erreur);
      annule = true;
    }

    attente.close();
    canevas.width = canevas.height = 0;

    // Format de la feuille d'après la première page du PDF, comme pdf.js (les autres pages s'y ajustent)
    const premiere = (await pdf.getPage(1)).getViewport({ scale: 1 });
    const formatFeuille = document.createElement('style');
    formatFeuille.textContent = `@page { size: ${premiere.width}pt ${premiere.height}pt; margin: 0; }`;

    const nettoyer = () => {
      conteneur.remove();
      formatFeuille.remove();
      urls.forEach((url) => URL.revokeObjectURL(url));
      enCours = false;
    };

    if (annule) {
      nettoyer();
      return;
    }

    document.head.append(formatFeuille);
    document.body.append(conteneur);
    window.addEventListener('afterprint', nettoyer, { once: true });
    window.print();
  };

  bouton.hidden = false;
  bouton.addEventListener('click', imprimer);

  document.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && !e.altKey && e.key.toLowerCase() === 'p') {
      e.preventDefault();
      imprimer();
    }
  });
}
